import { getDeviceId } from '../utils/device-id';

const bifrostConstants = {
  qa: {
    CLIENT_ID: 'client_L5wNscsU1_bv3A3w2wmUOg',
    AUTH_API_BASE_URL: 'https://auth-service-qa.qac24svc.dev',
    REDIRECT_URI: `${window.location.origin}`,
    USER_PROFILE_BASE_URL: 'https://c24-user-service-qa.qac24svc.dev',
  },
  staging: {
    CLIENT_ID: 'client_B-BxcS0Ua4DsBN3JQ8-wzg',
    AUTH_API_BASE_URL: 'https://auth-service-stage.qac24svc.dev',
    REDIRECT_URI: `${window.location.origin}`,
    USER_PROFILE_BASE_URL: 'https://c24-user-service-stage.qac24svc.dev',
  },
  prod: {
    CLIENT_ID: 'client_YDukDwDxb9-Oqy5yen8sQQ',
    AUTH_API_BASE_URL: 'https://auth.c24.tech',
    REDIRECT_URI: 'https://b2c-admin-panel.c24.tech',
    USER_PROFILE_BASE_URL: 'https://api.cars24.com/gw/plt/usersvc',
  },
};

let config;

switch (process.env.REACT_APP_ENV) {
  case 'qa':
    config = bifrostConstants.qa;
    break;
  case 'staging':
    config = bifrostConstants.staging;
    break;
  case 'prod':
    config = bifrostConstants.prod;
    break;
  default:
    config = bifrostConstants.qa;
    break;
}

export const bifrostConfig = {
  authApiBaseUrl: config.AUTH_API_BASE_URL,
  clientId: config.CLIENT_ID,
  deviceId: getDeviceId(),
  redirectUri: config.REDIRECT_URI,
  userProfileBaseUrl: config.USER_PROFILE_BASE_URL,
};

const FILE_VERSION = process.env.REACT_APP_FILE_VERSION;
